export const API_GET_TEAM_MEMBERS_FULL_REQUEST = 'API_GET_TEAM_MEMBERS_FULL_REQUEST';
export const API_GET_TEAM_MEMBERS_FULL_SUCCESS = 'API_GET_TEAM_MEMBERS_FULL_SUCCESS';
export const API_GET_TEAM_MEMBERS_FULL_FAILURE = 'API_GET_TEAM_MEMBERS_FULL_FAILURE';

export const FILTER_TEAM_MEMBERS = 'FILTER_TEAM_MEMBERS';

export const SELECT_TEAM_MEMBER = 'SELECT_TEAM_MEMBER';
export const SELECT_THINKTOOL = 'SELECT_THINKTOOL';
export const SELECT_VERSION = 'SELECT_VERSION';
export const SELECT_MESSAGE = 'SELECT_MESSAGE';

export const RESET_SELECTION_MESSAGE = 'SELECT_MESSAGE';
export const RESET_TEAM_MEMBERS = 'RESET_TEAM_MEMBERS';

export const resetTeamMembers = () => ({
  type: RESET_TEAM_MEMBERS,
});

export const selectTeamMember = payload => ({
  type: SELECT_TEAM_MEMBER,
  payload,
});

export const selectThinkTool = payload => ({
  type: SELECT_THINKTOOL,
  payload,
});
export const selectVersion = payload => ({
  type: SELECT_VERSION,
  payload,
});
export const selectMessage = payload => ({
  type: SELECT_MESSAGE,
  payload,
});
export const resetSelectionMessage = payload => ({
  type: RESET_SELECTION_MESSAGE,
  payload,
});

export const filterTeamMembers = payload => ({
  type: FILTER_TEAM_MEMBERS,
  payload,
});

export const getTeamMembersFullRequest = payload => ({
  type: API_GET_TEAM_MEMBERS_FULL_REQUEST,
  payload,
});

export const getTeamMembersFullSuccess = payload => ({
  type: API_GET_TEAM_MEMBERS_FULL_SUCCESS,
  payload,
});

export const getTeamMembersFullFailure = payload => ({
  type: API_GET_TEAM_MEMBERS_FULL_FAILURE,
  payload,
});

const initialState = {
  searchTerm: '',
  selectedTeamMemberId: null,
  selectedThinkToolId: null,
  selectedVersionId: null,
  selectedMessageId: null,
  isFetched: false,
  fetching: false,
  error: null,
  users: null,
  programs:null,
  report:null,
  projects:null
};

export function teamMembersFullReducer(state = initialState, action) {
  switch (action.type) {
    case RESET_TEAM_MEMBERS:
      return {
        ...state,
        users: null,
        isFetched: false,
      };
    case SELECT_TEAM_MEMBER:
      return {
        ...state,
        selectedTeamMemberId: action.payload,
      };
    case SELECT_THINKTOOL:
      return {
        ...state,
        selectedThinkToolId: action.payload,
      };
    case SELECT_VERSION:
      return {
        ...state,
        selectedVersionId: action.payload,
      };
    case SELECT_MESSAGE:
      return {
        ...state,
        selectedMessageId: action.payload,
      };
    case RESET_SELECTION_MESSAGE:
      return {
        ...state,
        selectedMessageId: null,
      };
    case FILTER_TEAM_MEMBERS:
      return {
        ...state,
        searchTerm: action.payload,
      };
    case API_GET_TEAM_MEMBERS_FULL_REQUEST:
      return {
        ...state,
        fetching: true,
      };
    case API_GET_TEAM_MEMBERS_FULL_SUCCESS:
      console.log('SDSDS', action.payload)
      return {
        ...state,
        isFetched: true,
        fetching: false,
        projects: action.payload.projects,
        report: action.payload.report
      };
    case API_GET_TEAM_MEMBERS_FULL_FAILURE:
      return {
        ...state,
        fetching: false,
        error: action.payload,
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/teamMembersFull.js